import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface Todo {
  id: number;
  title: string;
  completed: boolean;
  editing: boolean;
}

@Component({
  selector: 'app-todo',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './todo.component.html',
  styleUrl: './todo.component.scss'
})
export class TodoComponent implements OnInit {
  @Input() stats: any;
  @Input() title: any;

  task = '';
  todos: Todo[] = [];

  ngOnInit(): void {
    this.loadTodos();
  }

  addTask(): void {

    const value = this.task.trim();

    if (!value) return;

    this.todos.unshift({
      id: Date.now(),
      title: value,
      completed: false,
      editing: false
    });

    this.task = '';

    this.saveTodos();
  }

  deleteTask(id: number): void {
    this.todos = this.todos.filter(x => x.id !== id);
    this.saveTodos();
  }

  toggleComplete(todo: Todo): void {
    todo.completed = !todo.completed;
    this.saveTodos();
  }

  editTask(todo: Todo): void {
    todo.editing = true;
  }

  saveEdit(todo: Todo): void {

    if (!todo.title.trim()) {
      this.deleteTask(todo.id);
      return;
    }

    todo.editing = false;
    this.saveTodos();
  }

  cancelEdit(todo: Todo): void {
    todo.editing = false;
  }

  get completedCount(): number {
    return this.todos.filter(x => x.completed).length;
  }

  get pendingCount(): number {
    return this.todos.filter(x => !x.completed).length;
  }

  saveTodos(): void {
    localStorage.setItem('todos', JSON.stringify(this.todos));
  }

  loadTodos(): void {
    const data = localStorage.getItem('todos');

    if (data) {
      this.todos = JSON.parse(data);
    }
  }
}